<template>
  <div ref="controlsPanel" class="controls" @click="onControlsPanelClicked">
    <!--
     <template v-if="mode !== 'editing'">
       -->
       <!-- video controls, some controls are available for some state only. e.g. if a scene is selected -->
     <template>
        <div class="controls__play">
          <!--
          <h3 clasS="controls__label">VIDEO CONTROLS</h3>
          -->
          <button class="round-icon-button" v-tooltip.bottom-center="'toggle play / pause'" @click.prevent="onTogglePlay" v-bind:disabled="!player">
            <i v-if="isPlayerPaused" class="material-icons">play_arrow</i>
            <i v-else class="material-icons">pause</i>
          </button>
            <button v-tooltip.bottom-center="'mute video'" class="round-icon-button" @click.prevent="mute" >
              <i class="material-icons">{{isMuted ? 'volume_off' : 'volume_up'}}</i>
            </button>
            <button v-tooltip.bottom-center="'skip frame. Shift+Click -1s'" class="round-icon-button" @click.prevent="minus" >
              <i class="material-icons">keyboard_arrow_left</i>
            </button>
            <button v-tooltip.bottom-center="'skip frame. Shift+Click +1s'" class="round-icon-button" @click.prevent="plus" >
              <i class="material-icons">keyboard_arrow_right</i>
            </button>

            <button v-tooltip.bottom-center="'hold for fast backwards'"  class="round-icon-button" @mousedown.prevent="fastPlayBW(true)" @mouseup.prevent="fastPlayBW(false)">
            <i class="material-icons">fast_rewind</i>
          </button>
            <button v-tooltip.bottom-center="'hold for fast forward'"  class="round-icon-button" @mousedown.prevent="fastPlayFW(true)" @mouseup.prevent="fastPlayFW(false)">
            <i class="material-icons">fast_forward</i>
          </button>

          <!-- a replay / pause of the selected scene, visible if not appropriate -->
          <button v-tooltip.bottom-center="'replay selected scene'" class="round-icon-button" v-bind:disabled="!selection.scene && !selection.waypoint" @click.prevent="replay">
            <i class="material-icons">replay</i>
          </button>

          <button v-tooltip.bottom-center="'select previous waypoint'" class="round-icon-button" v-bind:disabled="!selection.scene && !selection.waypoint" @click.prevent="previousWaypoint">
            <i class="material-icons">skip_previous</i>
          </button>

           <button v-tooltip.bottom-center="'select next waypoint'" class="round-icon-button" v-bind:disabled="!selection.scene && !selection.waypoint" @click.prevent="nextWaypoint">
            <i class="material-icons">skip_next</i>
          </button>

     
      <!---->

            <!--
          <button v-tooltip.bottom-center="'skip to start'" class="round-icon-button" @click.prevent="bbwd">
              <i class="material-icons">skip_previous</i>
            </button>
            <button v-tooltip.bottom-center="'skip to end'" class="round-icon-button" @click.prevent="ffwd">
              <i class="material-icons">skip_next</i>
            </button>
            -->
        </div>

      <!---->
      <div v-if="this.video" class="controls__time">
        <!--
        <h3 clasS="controls__label">VIDEO TIME / DURATION</h3>
        -->
        <div class="controls__content">
          <div class="time-display">
            {{displayTime}}
          </div>
        </div>
      </div>
      <div v-if="this.video" class="controls__time">
        <div class="controls__content">
          <div class="time-display">
            {{getFrameRate}} fps
          </div>
        </div>
      </div>
      <!---->
      <div v-if="this.video" class="controls__time">
        <!--
        <h3 clasS="controls__label">CURRENT TIME</h3>
        -->
        <!--<div class="controls__content">
          <input type="number" min=0 :max="videoDuration" class="time-control" maxlength="9" :value="currentTime" @input="setManualTime($event)" />
        </div>-->
        <div class="controls__content">
          <!--<input type="text" class="time-control" v-model="timeInput" @keyup.enter="onEnterTime"/>-->
          <time-input :currentTime="currentTime" :frameRate="getFrameRate" @timeChange="(time) => setPlayerTime(time)"/>
        </div>
      </div>

      <div v-if="this.video" class="controls__resolution" v-tooltip.bottom-center="'current video resolution'">
        <div class="controls__content">
          <div class="resolution-display">
            {{`Current res: ${Math.round(this.video.dimensions.width)}x${Math.round(this.video.dimensions.height)}px`}}
          </div>
        </div>
      </div>
      <div v-if="this.video" class="controls__resolution" v-tooltip.bottom-center="'original video resolution'">
        <div class="controls__content">
          <div class="resolution-display">
            {{`Original res: ${this.video.meta.width}x${this.video.meta.height}px`}}
          </div>
        </div>
      </div>
      <!--
      <div v-if="mode === 'editing'"  class="controls__scenes">
        <h3 clasS="controls__label">SCENE</h3>
        <div class="controls__content">
          <button v-tooltip.bottom-center="'commit selected scene'" class="round-icon-button" v-bind:disabled="!selection.scene" @click.prevent="commitScene" >
            <i class="material-icons">check</i>
          </button>
          <button v-tooltip.bottom-center="'delete selected scene'"  class="round-icon-button" v-bind:disabled="!selection.scene"  @click.prevent="onDeleteScene" >
            <i class="material-icons">delete</i>
          </button>
          <button v-tooltip.bottom-center="'add a new scene'" class="round-icon-button" v-bind:disabled="selection.scene"  @click.prevent="onCreateScene" >
            <i class="material-icons">add</i>
          </button>
        </div>
      </div>
      -->
      <!---->
      <div v-if="mode === 'editing'" class="controls__done">
        <button class="round-icon-button delete-btn" v-tooltip.bottom-center="'delete'" v-if="mode === 'editing'" @click.prevent="onDeleteTag">
             <i class="material-icons">delete</i>
        </button>
        <button class="round-icon-button" v-tooltip.bottom-center="'close'" v-if="mode === 'editing'" @click.prevent="saveScene">
             <i class="material-icons">done</i>
        </button>
      </div>


    </template>

<!--
    <template v-if="mode === 'all-off'">
        <div class="controls__play" :class="{'is-hidden': (selection.scene || selection.waypoint)}">
        <h3 clasS="controls__label">PLAY TAG</h3>
        <div class="controls__content">
          <button v-tooltip.bottom-center="'stop'" class="round-icon-button" v-bind:disabled="selection.scene || selection.waypoint" @click.prevent="pause">
            <i class="material-icons">stop</i>
          </button>
          <button v-tooltip.bottom-center="'play'" class="round-icon-button" v-bind:disabled="selection.scene || selection.waypoint" @click.prevent="play">
            <i class="material-icons">play_arrow</i>
          </button>
          <button v-tooltip.bottom-center="'skip to start'" class="round-icon-button" v-bind:disabled="selection.scene || selection.waypoint" @click.prevent="bbwd">
            <i class="material-icons">skip_previous</i>
          </button>
          <button v-tooltip.bottom-center="'skip to end'" class="round-icon-button" v-bind:disabled="selection.scene || selection.waypoint" @click.prevent="ffwd">
            <i class="material-icons">skip_next</i>
          </button>
        </div>
      </div>
      <div class="controls__replay" :class="{'is-hidden': (!selection.scene || selection.waypoint)}">
        <h3 clasS="controls__label">CONTINUE PlAY / REPLAY SCENE</h3>
        <div class="controls__content">
          <button v-tooltip.bottom-center="'stop'" class="round-icon-button" v-bind:disabled="!selection.scene || selection.waypoint" @click.prevent="pause">
            <i class="material-icons">stop</i>
          </button>
          <button v-tooltip.bottom-center="'continue scene play'" class="round-icon-button" v-bind:disabled="!selection.scene || selection.waypoint" @click.prevent="playOn">
            <i class="material-icons">play_circle_filled</i>
          </button>
          <button v-tooltip.bottom-center="'replay this scene'" class="round-icon-button" v-bind:disabled="!selection.scene || selection.waypoint" @click.prevent="replay">
            <i class="material-icons">replay</i>
          </button>
          <button v-tooltip.bottom-center="'hold for fast backwards'"  class="round-icon-button"  @mousedown.prevent="fastPlayBW(true)" @mouseup.prevent="fastPlayBW(false)">
            <i class="material-icons">fast_rewind</i>
          </button>
            <button v-tooltip.bottom-center="'hold for fast forward'"  class="round-icon-button"  v-bind:disabled="!selection.scene || selection.waypoint" @mousedown.prevent="fastPlayFW(true)" @mouseup.prevent="fastPlayFW(false)">
            <i class="material-icons">fast_forward</i>
          </button>
        </div>
      </div>

      <div class="controls__waypoints">
        <h3 clasS="controls__label">SELECT WAYPOINT</h3>
        <div class="controls__content">
          <button class="round-icon-button" @click.prevent="bbwd" >
            <i class="material-icons">skip_previous</i>
          </button>
          <button class="round-icon-button"  @click.prevent="ffwd" >
            <i class="material-icons">skip_next</i>
          </button>
        </div>
      </div>

      <div class="controls__waypoints" :class="{'is-hidden': !selection.waypoint}">
        <h3 clasS="controls__label">SET WAYPOINT TIME / FRAME</h3>
        <div class="controls__content">
          <button v-tooltip.bottom-center="'continue scene play'" class="round-icon-button" v-bind:disabled="!selection.waypoint" @click.prevent="playOn">
            <i class="material-icons">play_circle_filled</i>
          </button>
          <button v-tooltip.bottom-center="'hold for fast backwards'"  class="round-icon-button" v-bind:disabled="!selection.waypoint" @mousedown.prevent="fastPlayBW(true)" @mouseup.prevent="fastPlayBW(false)">
            <i class="material-icons">fast_rewind</i>
          </button>
          <button v-tooltip.bottom-center="'skip frame. Shift+Click -1s'" class="round-icon-button"  v-bind:disabled="!selection.waypoint"  @click.prevent="minus" >
            <i class="material-icons">keyboard_arrow_left</i>
          </button>
          <button v-tooltip.bottom-center="'skip frame. Shift+Click +1s'" class="round-icon-button"  v-bind:disabled="!selection.waypoint"  @click.prevent="plus" >
            <i class="material-icons">keyboard_arrow_right</i>
          </button>
          <button v-tooltip.bottom-center="'hold for fast forward'"  class="round-icon-button"  v-bind:disabled="!selection.waypoint" @mousedown.prevent="fastPlayFW(true)" @mouseup.prevent="fastPlayFW(false)">
            <i class="material-icons">fast_forward</i>
          </button>
        </div>
      </div>

      <div class="controls__tracker">
        <h3 clasS="controls__label">TRACKER</h3>
        <div class="controls__content">
          <button v-tooltip.bottom-center="'start tracking from selected waypoint'" class="button" :class="{'is-tracking': isTracking}" v-bind:disabled="!selection.scene || !selection.waypoint" @click.prevent="onStartTracker" >
            <i class="material-icons">gps_fixed</i>
          </button>
          <button class="button" v-tooltip.bottom-center="'remove last tracked waypoints'"  v-bind:disabled="isTracking || !selection.scene" @click.prevent="onRemoveTracked" >
            <i class="material-icons">not_interested</i>
          </button>
        </div>
      </div>
     
      <div class="controls__scenes">
        <h3 clasS="controls__label">SCENE</h3>
        <div class="controls__content">
          <button v-tooltip.bottom-center="'scene ok'" class="round-icon-button" v-bind:disabled="!selection.scene" @click.prevent="commitScene" >
            <i class="material-icons">check</i>
          </button>
          <button v-tooltip.bottom-center="'scene delete'"  class="round-icon-button" v-bind:disabled="!selection.scene"  @click.prevent="onDeleteScene" >
            <i class="material-icons">delete</i>
          </button>
          <button v-tooltip.bottom-center="'add scene'" class="round-icon-button" v-bind:disabled="selection.scene"  @click.prevent="onCreateScene" >
            <i class="material-icons">add</i>
          </button>
        </div>
      </div>

      <div class="controls__done">
        <button class="button is-primary" v-if="mode === 'editing'" @click.prevent="saveScene">
            OK
        </button>
      </div>
    </template>
    -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import guid from '../../utils/guid'
import timeConversion from '../../utils/timeConversion'
import helpers from '../../store/helpers';
import timeInput from '../core/timeInput'

export default {
  name: 'controls',

  components: {
    'time-input': timeInput
  },

  data() {
    return {
      pauseStateTrigger: 0,
      isMuted: false
    }
  },

  computed: {
    ...mapState(['video', 'player', 'selection', 'mode']),
    ...mapGetters(['currentTime', 'videoDuration', 'getFrameRate']),

    isTracking: function () {
      return this.video.tracking.isPending
    },

    isPlayerPaused: function() {
      // state trigger is here as there player.paused() from external api is not reactive
      return this.player.paused()
    },

    displayTime: function () {
      return `${timeConversion.secondsToString(this.currentTime)} / ${timeConversion.secondsToString(this.videoDuration)}`
    },

  },

  watch: {
    'isTracking': 'updateOnTrackingState'
  },

  methods: {
    ...mapMutations(['setPlayerTime', 'selectScene', 'setMode', 'deleteScene', 'deleteTag', 'selectWaypoint', 'commitWaypoint', 'removeTrackedWaypoints', 'promoteTrackedWaypoints', 'resetSelection']),
    ...mapActions(['createScene', 'startTracker', 'createTag']),

    // Tracker is working in multiple steps, so we need to track the state, this is to select the end waypoint when tracking is complete
    updateOnTrackingState: function (isTracking) {
      console.log('updateOnTrackingState', isTracking)
      if (!isTracking) {
        this.selectWaypoint(this.trackToWP || this.trackFromWP)
      }
    },
  
    bbwd: function () {
      this.setPlayerTime(0)
    },
  
    ffwd: function () {
      this.setPlayerTime(this.videoDuration)
      
    },
  
    minus: function (e) {
      var t = (1 / this.getFrameRate)
      if (e.shiftKey) t = 1
      this.setPlayerTime(this.currentTime - t)
      this.pauseStateTrigger = this.pauseStateTrigger + 1
    },
  
    plus: function (e) {
      var t = (1 / this.getFrameRate)
      if (e.shiftKey) t = 1
      this.setPlayerTime(this.currentTime + t)
      this.pauseStateTrigger = this.pauseStateTrigger + 1
    },

    mute() {
      this.isMuted = !this.isMuted
      this.$emit('mute')
    },
  
    play: function () {
      clearInterval(this.intervalRewind)
      this.player.play()
    },
  
    playOn: function () {
      if (this.player.paused()) {
        this.player.play()
        this.pauseStateTrigger = this.pauseStateTrigger + 1
      } else {
        this.player.pause()
        this.pauseStateTrigger = this.pauseStateTrigger + 1
      }
    },
  
    setManualTime: function (ev) {
      let val = Math.round(ev.target.value * 25) / 25

      this.setPlayerTime(val)
    },
  
    replay: function() {
       clearInterval(this.intervalRewind)
      const t = this.selection.scene.waypoints.reduce((min, wp) => {
        min = Math.min(min, wp.time)
        return min
      }, Number.MAX_VALUE)

      this.setPlayerTime(t - 0.25)
      this.player.play()
      this.pauseStateTrigger = this.pauseStateTrigger + 1
    },
  
    pause: function () {
      clearInterval(this.intervalRewind)
      this.player.pause()
      this.pauseStateTrigger = this.pauseStateTrigger + 1

    },

    previousWaypoint: function() {
      const wp = helpers.findPreviousWaypoint(this.selection.waypoint)
      this.selectWaypoint(wp)
      this.pauseStateTrigger = this.pauseStateTrigger + 1
    },

    nextWaypoint: function() {
      const wp = helpers.findNextWaypoint(this.selection.waypoint)
      this.selectWaypoint(wp)
      this.pauseStateTrigger = this.pauseStateTrigger + 1
    },
 
    commitScene: function () {
      this.selectScene(null)
    },
  
    onDeleteScene: function () {
      this.deleteScene(this.selection.scene)
    },

    onDeleteTag: function () {
      const options = {title: 'Delete tag?', cancelLabel: 'Cancel'}
      this.$dialogs.confirm('Do you want to delete this tag?', options)
      .then((res) => {
        if (res.ok) {
          this.deleteTag(this.selection.tag);
          this.setMode(null)
        }
      })
    },

    onCreateTag: function() {
      this.player.pause()
      this.pauseStateTrigger = this.pauseStateTrigger + 1
      let tag = this.createTag()
      this.onCreateScene()
    },
  
    onCreateScene: function () {
      const time = this.player.currentTime()
      const w = 80
      const h = 80
      const wp1 = { time, x: 0.5, y: 0.5, w, h, id: guid() }
      /*
      const wp2 = {
        time: wp1.time + 2,
        x: wp1.x,
        y: wp1.y + 0.1,
        w: wp1.w,
        h: wp1.h,
        id: guid()
      }
      */
      this.createScene([wp1]).then(newScene => { this.selectScene(newScene); this.selectWaypoint(wp1) }).catch(e => console.error('failed to create new scene', e))
    },
  
    fastPlayFW: function (doPlay) {
      this.pauseStateTrigger = this.pauseStateTrigger + 1

      if (doPlay) {
        this.fastPlay(doPlay, () => this.player.currentTime(this.player.currentTime() + 1 / 15))
        
      } else {
        this.fastPlay(doPlay, () => this.player.pause())
      }
    },
  
    fastPlayBW: function (doPlay) {
      this.pauseStateTrigger = this.pauseStateTrigger + 1

      if (doPlay) {
        this.fastPlay(doPlay, () => this.player.currentTime(this.player.currentTime() - 1 / 15))
      } else {
        this.fastPlay(doPlay, () => this.player.pause())
      }
    },
  
    fastPlay: function (doPlay, cb) {
      if (doPlay) {
        // make that to never have more than 1 interval running
        if (this.intervalRewind >= 0) {
            clearInterval(this.intervalRewind)
        }
        this.player.play()

        this.intervalRewind = setInterval(() => {
          this.player.playbackRate = 1

          if (this.player.currentTime() === 0) {
            clearInterval(this.intervalRewind)
            this.intervalRewind = -1
            this.player.pause()
          } else {
            cb()
          }
        }, 1000 / 24)
      } else {
        clearInterval(this.intervalRewind)
        this.intervalRewind = -1
        cb()
      }
    },

    onTogglePlay() {
      if (this.player) {
        if (this.player.paused()) {
          this.player.play()
          this.pauseStateTrigger = this.pauseStateTrigger + 1
        } else {
          this.player.pause()
          this.pauseStateTrigger = this.pauseStateTrigger + 1
        }
      }
    },
  
    onStartTracker: function () {
      // TODO: stop tracker
      this.trackFromWP = this.selection.waypoint
      // commit the tracked waypoint -> deselects for tracking
      this.commitWaypoint(this.trackFromWP)
      // promote any previously tracked wps to manual
      this.promoteTrackedWaypoints()
      // find the end to track
      const idx = this.selection.scene.waypoints.indexOf(this.trackFromWP)
      this.trackToWP = this.selection.scene.waypoints[idx + 1]
      // kick of tracker
      this.startTracker({trackFromWaypoint: this.trackFromWP, trackToWaypoint: this.trackToWP})
    },
  
    onRemoveTracked: function () {
      // if tracked wps are crap, gives the user the option the remove the just tracked wps
      this.removeTrackedWaypoints()
    },
  
    saveScene: function() {
      this.$emit('saveScene')
    },

    onControlsPanelClicked(ev) {
      if (this.selection.tag && ev.target === this.$refs.controlsPanel) {
        this.saveScene()
      }
    }
  }
}
</script>
